import * as React from "react";
const SvgGcal = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m17.263 6.737-4.737-.526-5.79.526L6.21 12l.527 5.263 5.263.658 5.263-.658.526-5.395z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1A73E8",
  d: "M8.896 14.903q-.59-.398-.814-1.168l.913-.376q.124.473.434.734.308.26.747.26.45 0 .77-.273a.87.87 0 0 0 .322-.693.86.86 0 0 0-.339-.703q-.34-.272-.85-.272h-.528v-.904h.474q.438 0 .738-.237t.3-.649q0-.367-.268-.585-.269-.22-.68-.22-.403 0-.64.215-.236.216-.345.527l-.904-.376q.18-.51.662-.899.484-.39 1.234-.39.555 0 .998.215.443.216.693.595.25.38.25.854 0 .483-.233.818a1.6 1.6 0 0 1-.572.515v.054q.447.188.734.572a1.5 1.5 0 0 1 .287.921q0 .538-.272.958-.273.42-.752.662-.48.241-1.077.242a2.23 2.23 0 0 1-1.282-.397M14.5 10.371l-.997.725-.502-.76L14.8 9.038h.69v6.12h-.99z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M17.263 22 22 17.263l-2.368-1.052-2.369 1.052-1.052 2.369z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M5.684 19.632 6.737 22h10.526v-4.737H6.737z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M3.579 2C2.707 2 2 2.707 2 3.579v13.684l2.368 1.053 2.369-1.053V6.737h10.526l1.053-2.369L17.263 2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#188038",
  d: "M2 17.263v3.158C2 21.294 2.707 22 3.579 22h3.158v-4.737z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC04",
  d: "M17.263 6.737v10.526H22V6.737l-2.368-1.053z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1967D2",
  d: "M22 6.737V3.579C22 2.707 21.293 2 20.421 2h-3.158v4.737z"
}));
export default SvgGcal;
//# sourceMappingURL=Gcal.js.map